import { cn } from '@/lib/utils';
import Footer from './Footer';

export default function PageLayout({ children, padded = false, gapPx = 20, applyMaxWidth = true }) {
  //const [cart, cartDispatch] = useReducer < CartInfo > ();

  const paddingValues = {
    20: 'gap-5',
    30: 'gap-[30px]'
  }

  return (
    <div className="relative bg-white text-black max-w-[100vw]">
      {
        applyMaxWidth ? (
          <div className="w-full flex flex-col items-center justify-center">
            <main className={"min-h-[90vh] w-full max-w-[1920px]" + (padded ? " flex flex-col md:py-5 md:px-[60px] py-2.5 px-[30px]" : "") + ` ${paddingValues[gapPx]}`}>
              {children}
            </main>
          </div>
        ) : (
          <main className={"min-h-[90vh]" + (padded ? " flex flex-col md:py-5 md:px-[60px] py-2.5 px-[30px]" : "") + ` ${paddingValues[gapPx]}`}>
            {children}
          </main>
        )
      }
      <Footer />
    </div>
  );
}
